import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { Card, CardLabel, DarkCard, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
const oneOffs = [{
  label: 'Brand snakification, one off',
  value: '€66,000'
}, {
  label: '5 Master Snak campaigns, one off',
  value: '€15,000'
}];
const marginal = [{
  label: 'Localization, per market',
  value: '€1,000'
}, {
  label: 'Activation, per campaign / month',
  value: '€99'
}];
export function ScalingSlide() {
  return <Slide data-id="element-197" data-mp="1ng5h14kt1zas">
      <SlideHeader eyebrow="Scaling fairly across local markets" data-id="element-198" data-mp="1nfvrtj7l3w65">
        The heavy lifting is paid once, centrally.{' '}
        <Hi data-id="element-199" data-mp="1s6lx6wg0fz0u">No market is billed twice for the same build.</Hi>
      </SlideHeader>

      <div className="flex min-h-0 flex-1 flex-col gap-[clamp(0.5rem,1vw,1rem)]" data-id="element-200" data-mp="1w8z07d3dhitx">
        <Fade delay={0.2} className="flex flex-1" data-id="element-201" data-mp="217k35ka0egm2">
          <DarkCard className="flex flex-1 items-center gap-[clamp(1.5rem,3vw,3rem)]" data-id="element-202" data-mp="218v6xk3gfod6">
            <div className="w-[26%] flex-shrink-0" data-id="element-203" data-mp="267og50bpkt7j">
              <CardLabel tone="light" data-id="element-204" data-mp="2g2ck2jqqfivf">Built once, centrally</CardLabel>
              <p className="mt-2 text-[clamp(0.8rem,1vw,1rem)] leading-relaxed text-white/70" data-id="element-205" data-mp="2g3npsp3qn0p6">
                Global funds the master build a single time.
              </p>
            </div>
            <div className="flex flex-1 items-stretch gap-[clamp(1.5rem,3vw,3rem)]" data-id="element-206" data-mp="2727mt2f960uz">
              {oneOffs.map(item => <div key={item.label} className="flex-1" data-id="element-207" data-mp="224xsp9gx510t">
                  <p className="text-[clamp(1.5rem,3.2vw,3rem)] font-bold leading-none" data-id="element-208" data-mp="2yrkafmxoik4c">
                    {item.value}
                  </p>
                  <p className="mt-2 text-[clamp(0.8rem,1vw,1rem)] font-medium text-white/70" data-id="element-209" data-mp="2utmm0mbqg220">
                    {item.label}
                  </p>
                </div>)}
            </div>
          </DarkCard>
        </Fade>

        <Fade delay={0.35} className="flex items-center justify-center gap-3" data-id="element-210" data-mp="3ih35czh0smgt">
          <ArrowDownIcon className="h-5 w-5 text-[var(--brand-green)]" aria-hidden="true" data-id="element-211" data-mp="3dpl0i0bvm1qk" />
          <span className="text-[clamp(0.8rem,1vw,1rem)] font-semibold uppercase tracking-wide text-[var(--muted)]" data-id="element-212" data-mp="i0gfgrfx9z3">
            Then every additional market only pays
          </span>
        </Fade>

        <Fade delay={0.45} className="flex flex-1" data-id="element-213" data-mp="3nt008athg65s">
          <Card className="flex flex-1 items-center gap-[clamp(1.5rem,3vw,3rem)]" data-id="element-214" data-mp="3rvn0n047yzel">
            <div className="w-[26%] flex-shrink-0" data-id="element-215" data-mp="3rtjyjhpslfti">
              <CardLabel tone="muted" data-id="element-216" data-mp="3duu306imfo79">Marginal local cost</CardLabel>
              <p className="mt-2 text-[clamp(0.8rem,1vw,1rem)] leading-relaxed text-[var(--muted)]" data-id="element-217" data-mp="3iuotwa2ecdsb">
                Small markets adopt at a fraction of production cost.
              </p>
            </div>
            <div className="flex flex-1 items-stretch gap-[clamp(1.5rem,3vw,3rem)]" data-id="element-218" data-mp="38wivw3jpnrsq">
              {marginal.map(item => <div key={item.label} className="flex-1" data-id="element-219" data-mp="134vls41ryxiv">
                  <p className="text-[clamp(1.5rem,3.2vw,3rem)] font-bold leading-none text-[var(--brand-green)]" data-id="element-220" data-mp="175fe8ubelcyo">
                    {item.value}
                  </p>
                  <p className="mt-2 text-[clamp(0.8rem,1vw,1rem)] font-medium text-[var(--muted)]" data-id="element-221" data-mp="2rnq2h1br9t78">
                    {item.label}
                  </p>
                </div>)}
            </div>
          </Card>
        </Fade>
      </div>

      <Fade delay={0.6} className="mt-[clamp(0.75rem,1.5vw,1.5rem)] flex-shrink-0" data-id="element-222" data-mp="2wmb0cu3jc0si">
        <p className="border-l-2 border-[var(--brand-green)] pl-4 text-[clamp(0.95rem,1.35vw,1.35rem)] font-semibold text-[var(--fg)]" data-id="element-223" data-mp="3bb778ntuv7rj">
          Everyone gets premium content, regardless of local budget size.
        </p>
      </Fade>
    </Slide>;
}